/* eslint-disable class-methods-use-this */ import { UINotificationController } from '../../../shared/scripts/notifications/UINotificationController.ts';
import { UICornerNotificationController } from '../ui_corner_notification/UICornerNotificationController.ts';
import { UITopNotificationController } from '../ui_top_notification/UITopNotificationController.ts';
import { NotificationContentType } from '../../../shared/scripts/ui_utils/NotificationUtils.ts';
export class UIWNotificationController extends UINotificationController {
    show(text, type, buttonText, action, removeAction, showCloseButton = true, duration) {
        UITopNotificationController.show(text, type, buttonText, action, removeAction, showCloseButton, duration);
    }
    showNotification(icon, text, duration, action, removeAction, contentType = NotificationContentType.General) {
        UICornerNotificationController.showNotification(icon, text, duration, action, removeAction, undefined, contentType);
    }
    showGames(games) {
        UITopNotificationController.showGames(games);
    }
    removeDisconnectBanners() {
        UITopNotificationController.removeDisconnectBanners();
    }
    removeSocketErrorBanners() {
        UITopNotificationController.removeSocketErrorBanners();
    }
}
